// Importar el módulo Tab de Bootstrap desde node_modules
import Tab from "bootstrap/js/dist/tab";

const playVideoWhenReady = (video) => {
  if (!video) return;

  if (video.readyState >= 3) {
    video.play().catch(() => {});
    return;
  }

  const onCanPlay = () => {
    video.play().catch(() => {});
    video.removeEventListener("canplay", onCanPlay);
  };

  video.addEventListener("canplay", onCanPlay, { once: true });
  video.load();
};

const pauseAllVideosInBlock = (block) => {
  const videos = block.querySelectorAll("video");
  videos.forEach((video) => video.pause());
};

const playActivePaneVideo = (block, tabButton) => {
  if (!tabButton) return;

  const targetId = tabButton.getAttribute("data-bs-target");
  if (!targetId) return;

  const targetPane = block.querySelector(targetId);
  if (!targetPane) return;

  const video = targetPane.querySelector("video");
  playVideoWhenReady(video);
};

document.addEventListener("DOMContentLoaded", () => {
  const blocks = document.querySelectorAll(".tabs-with-media-block");

  blocks.forEach((block) => {
    const tabButtons = block.querySelectorAll('button[data-bs-toggle="pill"]');

    tabButtons.forEach((tabButton) => {
      Tab.getOrCreateInstance(tabButton);

      tabButton.addEventListener("shown.bs.tab", (event) => {
        const currentTab = event.target;
        pauseAllVideosInBlock(block);
        playActivePaneVideo(block, currentTab);
      });

      tabButton.addEventListener("hide.bs.tab", () => {
        pauseAllVideosInBlock(block);
      });
    });

    // Sincronizar estado inicial del primer tab con Bootstrap por bloque
    const firstTab = block.querySelector('button[data-bs-toggle="pill"]');
    if (firstTab) {
      Tab.getOrCreateInstance(firstTab).show();
      playActivePaneVideo(block, firstTab);
    }
  });
});
